import React from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'react-modal';
import { Icons, Button } from 'sarsaparilla';

const propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  errorMessage: PropTypes.string
};

export default class BookingErrorModal extends React.Component {
  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.closeModal}
        shouldCloseOnOverlayClick={false}
        role="complementary"
        className={{
          base: 'rec-modal-dialog-base',
          afterOpen: 'rec-modal-dialog-after-open-md per-unauth-modal',
          beforeClose: 'rec-modal-dialog-before-close'
        }}
        overlayClassName={{
          base: 'rec-overlay-base',
          afterOpen: 'rec-overlay-after-open',
          beforeClose: 'rec-overlay-before-close'
        }} >
        <div className="rec-modal-content-wrap">
          <Button type="button" className="rec-close-modal" onClick={this.props.closeModal}>
            <Icons.IconClose />
          </Button>
          <div className="per-unauth-modal-title-block">
            <h4>Error Creating Reservation</h4>
          </div>
          <br />
          <p>{this.props.errorMessage}</p>
        </div>
        <div className="rec-modal-actions-wrap">
          <Button
            className="rec-button-tertiary"
            onClick={this.props.closeModal}>Close
          </Button>
        </div>
      </Modal>
    );
  }
}

BookingErrorModal.propTypes = propTypes;
